// BEUS-11496 M3: 기존 Heatmap 화면 요청(params) -> api-hub `/v2/heatmap/*` 요청.
// 기존 dream-api `es_query_builder.get_query` 규칙을 따른다.
// - 기간: startDate·endDate(YYYY-MM-DD)는 apply timezone 기준 하루 단위, endDate 포함(ES `lte` 날짜 = 그날 끝까지).
//   `hour`가 있으면 그 시각 1시간(startDate THH ~ endDate THH 끝). v2는 [startAt, endAt) 정시 범위다.
// - existing true/false -> visitorType return/new, refer 'Direct' -> direct, 그 외 값 -> 그 referrer.
// - bab(없으면 false) -> abVariant variant/original. 기존 ES는 bAB term을 항상 건다(B 페이지 문서는 기본에서 빠짐).
// - utm {field: 값 또는 값 목록}, utid.
// 알 수 없는 AB 유형·잘못된 시간 범위·CTA·방문 빈도 조건이 있으면 supported=false와 이유를 돌려준다.
// 호출하는 쪽은 그때 기존 API를 그대로 쓴다(P0 D7 임시 채택 C안: 첫 화면에서는 이 필터를 빼고 안내, 10/7).

const UTM_FIELDS = ['source', 'medium', 'campaign', 'term', 'content']

function pad (n) {
  return String(n).padStart(2, '0')
}

function addDays (ymd, days) {
  const [y, m, d] = ymd.split('-').map(Number)
  const t = new Date(Date.UTC(y, m - 1, d + days))
  return `${t.getUTCFullYear()}-${pad(t.getUTCMonth() + 1)}-${pad(t.getUTCDate())}`
}

function addHour (ymd, hour) {
  // hour(0~23) + 1. 23시면 다음 날 00시.
  return hour === 23 ? `${addDays(ymd, 1)}T00` : `${ymd}T${pad(hour + 1)}`
}

export function unsupportedReason (params) {
  if (params.ctaDom && typeof params.ctaDom !== 'string') return 'cta'
  if (!params.ctaDom && params.freq && (!Array.isArray(params.freq) || params.freq.some(v => !Number.isInteger(v) || v === 0 || v < -1))) return 'frequency'
  if (params.abTestType && !['text', 'url'].includes(params.abTestType)) return 'abTestType'
  if (params.hourRange && !(/^\d{4}-\d{2}-\d{2}T(?:[01]\d|2[0-3])$/.test(params.startDate) && /^\d{4}-\d{2}-\d{2}T(?:[01]\d|2[0-3])$/.test(params.endDate))) return 'hourRange'
  return null
}

// tzOffset: apply timezone의 UTC offset(예: '+09:00'). 기존 ES는 apply timezone으로 날짜 경계를 정한다.
export function toV2Range (params, tzOffset = '+09:00') {
  const { startDate, endDate } = params
  if (params.hourRange) {
    const [endDay, endHour] = endDate.split('T')
    return { startAt: `${startDate}:00:00${tzOffset}`, endAt: `${addHour(endDay, Number(endHour))}:00:00${tzOffset}` }
  }
  if (params.hour !== undefined && params.hour !== null && params.hour !== '') {
    const h = Number(params.hour)
    return {
      startAt: `${startDate}T${pad(h)}:00:00${tzOffset}`,
      endAt: `${addHour(endDate, h)}:00:00${tzOffset}`
    }
  }
  return {
    startAt: `${startDate}T00:00:00${tzOffset}`,
    endAt: `${addDays(endDate, 1)}T00:00:00${tzOffset}`
  }
}

export function toV2Filters (params) {
  const filters = {}
  if (params.existing === true || params.existing === 'true') filters.visitorType = 'return'
  else if (params.existing === false || params.existing === 'false') filters.visitorType = 'new'
  else filters.visitorType = 'all'

  const refer = params.refer
  if (refer === undefined || refer === null || refer === 'all') filters.referrer = { type: 'all' }
  else if (refer === 'Direct') filters.referrer = { type: 'direct' }
  else filters.referrer = { type: 'value', value: refer }

  if (params.utm) {
    const utm = {}
    for (const key of UTM_FIELDS) {
      const v = params.utm[key]
      if (v !== undefined && v !== null && v !== '') utm[key] = Array.isArray(v) ? v.map(String) : [String(v)]
    }
    if (Object.keys(utm).length) filters.utm = utm
  }
  filters.abVariant = params.bab === true || params.bab === 'true' ? 'variant' : 'original'
  if (params.utid) filters.utid = String(params.utid)
  if (params.ctaDom) {
    filters.cohort = { cta: { dom: params.ctaDom, exclude: params.ctaExcept === true || params.ctaExcept === 'true' } }
  } else if (Array.isArray(params.freq) && params.freq.length) {
    const values = [...params.freq].sort((a, b) => a - b)
    const mode = params.freq_option === 'session' ? 'session' : 'pv'
    const minimum = values[0] === -1 ? (values[1] || (mode === 'session' ? 31 : 51)) : values[0]
    const frequency = { mode, minimum }
    if (values[0] !== -1) frequency.maximum = values[values.length - 1]
    filters.cohort = { frequency }
  }
  return filters
}

export function toV2Request (params, tzOffset = '+09:00') {
  const reason = unsupportedReason(params)
  if (reason) return { supported: false, reason }
  return {
    supported: true,
    body: {
      aid: params.aid,
      device: params.device,
      range: toV2Range(params, tzOffset),
      filters: toV2Filters(params)
    }
  }
}
